import React from 'react';
import { AppBar, Box, Button, Stack, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

const navItems = [
  { label: 'Dashboard', to: '/admin/dashboard' },
  { label: 'Postavke igre', to: '/admin/postavke-igre' },
  { label: 'Pitanja', to: '/admin/pitanja' },
  { label: 'Kvizovi', to: '/admin/kvizovi' },
  { label: 'Opće postavke', to: '/admin/opce-postavke' }
];

export function AdminLayout() {
  const location = useLocation();
  const { logout } = useAdminAuth();

  return (
    <>
      <AppBar position="static">
        <Toolbar sx={{ flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>Digital Escape Room Admin</Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {navItems.map((item) => (
              <Button
                key={item.to}
                component={RouterLink}
                to={item.to}
                color="inherit"
                variant={location.pathname === item.to ? 'outlined' : 'text'}
                sx={{ borderColor: 'rgba(255,255,255,0.5)' }}
              >
                {item.label}
              </Button>
            ))}
            <Button color="inherit" onClick={logout}>Odjava</Button>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box sx={{ py: 3 }}><Outlet /></Box>
    </>
  );
}
